import classNames from 'classnames';
import { Container } from 'react-bootstrap';
import styles from './Grid.module.scss';

const GridContainer = ({ children, className, smallAt = 'xs', ...props }) => {
  return (
    <Container className={classNames(styles['container'], styles[`small-at--${smallAt}`], className)} {...props}>
      {children}
    </Container>
  );
};

export { GridContainer as default, GridContainer };
